import { render, staticRenderFns } from "./TourType.vue?vue&type=template&id=66c6d86b&scoped=true"
import script from "./TourType.vue?vue&type=script&lang=js"
export * from "./TourType.vue?vue&type=script&lang=js"
import style0 from "./TourType.vue?vue&type=style&index=0&id=66c6d86b&prod&lang=scss"
import style1 from "./TourType.vue?vue&type=style&index=1&id=66c6d86b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c6d86b",
  null
  
)

export default component.exports